import React from 'react'
import { BirthdayCard } from './BirthdayCard'
import { CountryCard } from './CountryCard'
import { GenderCard } from './GenderCard'
import { AboutUsCard } from './AboutUsCard'
import { ActOnClimateCard } from './ActOnClimateCard'
import { OrganizationCard } from './OrganizationCard'
import { JobRoleCard } from './JobRoleCard'
import { SeniorityCard } from './SeniorityCard'
import { RenderItemProps } from '../types'
import { DebugItem } from '../shared'
import { WorkSatisfactionCard } from './WorkSatisfactionCard'
import { WorkConfidenceCard } from './WorkConfidenceCard'
import { LearningMotivationsCard } from './LearningMotivationsCard'

type QuestionKey =
  | 'birthday'
  | 'country'
  | 'gender'
  | 'inbound_source'
  | 'climate_priority'
  | 'satisfaction_at_work'
  | 'organization'
  | 'department'
  | 'seniority'
  | 'confidence_at_work'
  | 'learning_motivations'

const questionComponents: Partial<Record<QuestionKey, React.ComponentType>> = {
  birthday: BirthdayCard,
  country: CountryCard,
  gender: GenderCard,
  inbound_source: AboutUsCard,
  climate_priority: ActOnClimateCard,
  satisfaction_at_work: WorkSatisfactionCard,
  organization: OrganizationCard,
  department: JobRoleCard,
  seniority: SeniorityCard,
  confidence_at_work: WorkConfidenceCard,
  learning_motivations: LearningMotivationsCard,
}

export const ProfileQuestions = (props: RenderItemProps) => {
  const key = props?.item?.profile_prompt?.key

  if (!key) return null

  const Component = questionComponents[key] ?? (() => null)

  return <>
    <DebugItem {...props} />

    <Component {...props} />
  </>
}
